export enum PointsTransferType {
        Partner = 0,
        NonPartner = 1
}
